<template>
  <div>
    <div class="routerChange">
      <el-button v-show="downloadExcelShow" class="lookUp" type="danger" @click="download" :disabled="picload" icon="el-icon-download">下载</el-button>
      <el-button v-show="!downloadExcelShow" class="lookUp" type="warning" :loading="true" plain>下载..</el-button>
      <el-button class="goBack" @click="goBack">返回</el-button>
      <div class="projectInfo">
        <div class="blockHeader">
          <div class="redBlock"></div>
          <div class="headerText">{{projectDayName}}</div>
        </div>
        <div class="blockContent">
          <div class="blockItem">
            <div class="item_type1">
              <div class="itemLeft">作业名称</div>
              <div class="itemRight">
                <span class="infoShow">{{workObj.name}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">所属工程</div>
              <div class="itemRight">
                <span class="infoShow">{{projectName}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">施工方自评时间</div>
              <div class="itemRight">
                <span class="infoShow">{{comments.consUnitDate}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">监理方复评时间</div>
              <div class="itemRight">
                <span class="infoShow">{{comments.supervisorDate}}</span>
              </div>
            </div>
          </div>
          <div class="blockItem">
            <div class="item_type1">
              <div class="itemLeft">作业创建时间</div>
              <div class="itemRight">
                <span class="infoShow">{{workObj.createTime}}</span>
                </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">作业开工时间</div>
              <div class="itemRight">
                <span class="infoShow">{{workObj.startTime}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">作业计划竣工时间</div>
              <div class="itemRight">
                <span class="infoShow">{{workObj.planEndTime}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">作业实际完成时间</div>
              <div class="itemRight">
                <span class="infoShow">{{workObj.endTime}}</span>
              </div>
            </div>
          </div>
          <div class="blockItem">
            <div class="item_type1">
              <div class="itemLeft">施工单位</div>
              <div class="itemRight">
                <span class="infoShow">{{workObj.consUnit}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">监理单位</div>
              <div class="itemRight">
                <span class="infoShow">{{workObj.supervisor}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">作业负责人</div>
              <div class="itemRight">
                <span class="infoShow">
                  <span class="infoShow">{{workObj.principal}}</span>
                </span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">作业联系电话</div>
              <div class="itemRight">
                <span class="infoShow">
                  <span class="infoShow">
                      <span class="infoShow">{{workObj.principalPhone}}</span>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="blockItem">
            <div class="item_type2" v-if="detail.workType==3||detail.workType==4">
              <div class="itemLeft">作业总里程</div>
              <div class="itemRight">
                <span class="infoShow">{{detail.totalMileage}}km</span>
              </div>
            </div>
            <div class="item_type2" v-if="detail.workType==2||detail.workType==1">
              <div class="itemLeft">作业总面积</div>
              <div class="itemRight">
                <span class="infoShow">{{detail.totalArea}} M²</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">作业进度</div>
              <div class="itemRight">
                <span class="infoShow">
                  <span class="infoShow">{{detail.process *100}}%</span>
                </span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">作业类型</div>
              <div class="itemRight">
                <span class="infoShow">
                  <span class="infoShow">{{detail.workTypeText}}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="blockItem">
            <div class="item_type2">
                <div class="itemLeft">作业标段</div>
                <div class="itemRight">
                    <span class="infoShow">{{detail.sectionName}}</span>
                </div>
            </div>
            <div class="item_type2">
                <div class="itemLeft">作业设备</div>
                <div class="itemRight">
                    <span class="infoShow">{{equipNames}}</span>
                </div>
            </div>
          </div>
        </div>  
      </div>

      <!-- <div class="projectInfo" v-for="(item,index) in workList" :key="index">
        <reportWork :workInfo="item"></reportWork>
        <interventionEquip :workEquipList="item.equipList"></interventionEquip>
        <compaction :workInfo="item"></compaction>
      </div> -->
      <div class="projectInfo">
          <interventionEquip v-if="childShow" :workEquipList="workEquipList"></interventionEquip>
          <compaction v-if="childShow" :workInfo="detail" :projectCheck="true"></compaction>
      </div>

      <div class="projectInfo">
          <opinion :workId="workId" :attachments="attachments" :comments="comments" @changeCons="changeConsFun" @changeSuper="changeSupersFun" @changeRadio="changeRadioFun"></opinion>
      </div>
      
    </div>
    <div class="commitCon">
        <span class="searchInputText"><span style="color:red">*</span> 编号</span>
        <el-input placeholder="请输入报告编号" v-model="reportCode" :disabled="reportDis"></el-input>
        <span class="resetBtn" @click="resetOpinion">重置</span>
        <span class="commitBtn" @click="setOpinion">提交</span>
    </div>
  </div>
</template>

<script>
  import{
    getWorkReport,
    setCommentWork,
    setSupervisorWork
    } from '../../utils/api'
  import{dateFormat,getDateSeconds,dataURLtoFile} from '../../utils/commons'
//   import reportWork from './report/reportWork'
  import interventionEquip from './report/interventionEquip'
  import compaction from './report/compaction'
  import opinion from './report/opinion'
  import { Loading } from 'element-ui';
  import axios from 'axios';
  import Cookies from 'js-cookie'
  import { Message} from 'element-ui';
  export default {
    name      : 'app',
    data() {
      return {
        fileNum: '',
        // icv_legend: require('../../images/all/icvNum.png'),
        // rn_legend: require('../../images/all/rollNum.png'),
        arrowList: [
          {
            name: '工程中心',
            path: '/transfer/engineeringCenter'
          },
          {
            name: "作业验收",
            path: "/transfer/check",
          },
          {
              name: '',
              path: ''
          },
          {
              name: '',
              path: ''
          },
        ],
        projectName: '',
        workObj: {},
        detail: {},
        comments: {},
        attachments: [],
        projectDayName: '',
        workList: [],
        workId:'',
        workEquipList: [],
        childShow: false,
        loadingInstance: '',
        consUnitComment: '', //施工方意见
        reportCode: '', //编号
        supervisorComment: '', //监理意见
        passFlag: 2, //是否合格
        equipNames: '',
        reportDis: false,
        icv_legend:'',
        rn_legend:'',
        downloadExcelShow: true,
        picload:true
      }
    },
    computed:{

    },
    created(){
      this.icv_legend = JSON.parse(localStorage.getItem("setIcv_exam"));
      this.rn_legend = JSON.parse(localStorage.getItem("setRn_exam"));
    },
    mounted(){
      this.$store.commit('setArrowList', this.arrowList)
      // let params = this.$route.params
      this.workId = this.$route.query.workId
      // console.log(params)
      let set = {
        workId: this.$route.query.workId
      }
      // let set = {
      //   workId: 16
      // }
      this.loadingInstance = Loading.service({});
      getWorkReport(set).then((res)=>{
        console.log(res)
        if(res.data.code==500){
          // this.$message({
          //   message: res.data.message,
          //   type: 'warning'});
            setTimeout(()=>{
              this.$router.go(-1)
            },2000)
        }
        let workTypeList = this.$store.state.workTypeList
        let getData = res.data.content.info
        this.arrowList[2].name = getData.projectName
        this.projectName = getData.projectName
        this.arrowList[3].name = getData.workInfo.name 
        this.workObj = getData.workInfo
        this.equipNames = getData.equipNames
        this.detail = getData.detail
        this.detail.pecent = this.workObj.sumMileage==0 || this.workObj.curMileage==0?'0.0%':((this.workObj.curMileage*1/this.workObj.sumMileage*1)*100).toFixed(1) + '%'

        this.detail.workTypeText = workTypeList[this.detail.workType]
        this.comments = getData.comments
        this.attachments = getData.attachments
        this.reportCode = getData.comments.reportCode
        this.workEquipList = getData.detail.equipList
        // let getData = res.data.content.info
        this.projectDayName = getData.projectName+' '+getData.workInfo.name+ ' ' + '质量验收报告'
        this.childShow = true

        this.consUnitComment = getData.comments.consUnitComment
        this.supervisorComment = getData.comments.supervisorComment
        this.reportCode = getData.comments.reportCode
        this.passFlag = getData.comments.passFlag || '1'
        console.log(this.passFlag)
        this.loadingInstance.close();
        let timer=setInterval(()=>{
          if(this.$store.state.rn_view.length>0 && this.$store.state.icv_view.length>0){
              this.picload=false
              clearInterval(timer)
            }
        },200)
      })
      let nowDate = new Date()
      console.log(dateFormat(nowDate,'YYYY年MM月DD日'))
    },
    beforeDestroy(){
      this.loadingInstance.close();
    },
    methods: {
      resetOpinion: function(){
        let joinCode = localStorage.getItem("roleCode")
        this.comments.consUnitComment = this.consUnitComment 
        this.comments.supervisorComment = this.supervisorComment 
        if(joinCode == 'role-1ee79e33cca14137a11514b861c1a199'){
            //施工
            this.consUnitComment = ''
            this.comments.consUnitComment = ''
            this.reportCode = ''
            this.reportDis = false
        }else if(joinCode == 'role-7bb90c5570ae4fd8b029d2737f89b641'){
            //监理
            this.supervisorComment = ''
            this.comments.supervisorComment = ''
            this.passFlag = 0
        }else if(joinCode == 'role-admin'){
            //管理员
            this.consUnitComment = ''
            this.comments.consUnitComment = ''
            this.reportCode = ''
            this.supervisorComment = ''
            this.comments.supervisorComment = ''
            this.passFlag = 0
            this.reportDis = true
        }
      },
      setOpinion: function(){
        let joinCode = localStorage.getItem("roleCode")
        console.log(joinCode,"joincode")
        if(joinCode == 'role-1ee79e33cca14137a11514b861c1a199'){
            //施工
            if(this.consUnitComment == ''){
              Message.error('请填写施工单位意见')
              return
            }
            if(this.reportCode == ''){
              Message.error('请填写编号')
              return
            }
            if(this.detail.pecent.split('%')[0]<100){
                this.$confirm(
                '当前作业进度尚未完成,是否直接验收?',
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                  dangerouslyUseHTMLString: true
                }
              ).then(() => {
                let params = {
                  workId: this.workId,
                  consUnitComment: this.consUnitComment,
                  reportCode: this.reportCode
                }
                setCommentWork(params).then(res=>{
                  console.log(res)
                  if(res.data.code == 200){
                    Message.success('提交成功')
                  }else if(res.data.code == 500){
                    // Message.error('作业已验收，施工方意见不能修改')
                  }
                })
              });
            }else{
              let params = {
                workId: this.workId,
                consUnitComment: this.consUnitComment,
                reportCode: this.reportCode
              }
              setCommentWork(params).then(res=>{
                console.log(res)
                if(res.data.code == 200){
                  Message.success('提交成功')
                }else if(res.data.code == 500){
                    // Message.error('作业已验收，施工方意见不能修改')
                  }
              })
            }
        }else if(joinCode == 'role-7bb90c5570ae4fd8b029d2737f89b641'){
            //监理
            if(this.supervisorComment == ''){
              Message.error('请填写监理单位意见')
              return
            }
            if(this.passFlag == '2'){
              Message.error('请选择评定意见')
              return
            }
            if(this.detail.pecent.split('%')[0]<100){
                this.$confirm(
                '当前作业进度尚未完成,是否直接验收?',
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                  dangerouslyUseHTMLString: true
                }
              ).then(() => {
                let params = {
                  workId: this.workId,
                  supervisorComment: this.supervisorComment,
                  passFlag: this.passFlag
                }
                setSupervisorWork(params).then(res=>{
                  console.log(res)
                  if(res.data.code == 200){
                    Message.success('提交成功')
                  }
                })
              });
            }else{
              let params = {
                workId: this.workId,
                supervisorComment: this.supervisorComment,
                passFlag: this.passFlag
              }
              setSupervisorWork(params).then(res=>{
                console.log(res)
                if(res.data.code == 200){
                  Message.success('提交成功')
                }
              })
            }
        }else if(joinCode == 'role-admin'){
          //管理员
          if(this.consUnitComment == ''){
              Message.error('请填写施工单位意见')
              return
            }
            if(this.reportCode == ''){
              Message.error('请填写编号')
              return
            }
            if(this.supervisorComment == ''){
              Message.error('请填写监理单位意见')
              return
            }
            if(this.passFlag == '2'){
              Message.error('请选择评定意见')
              return
            }
            if(this.detail.pecent.split('%')[0]<100){
                this.$confirm(
                '当前作业进度尚未完成,是否直接验收?',
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                  dangerouslyUseHTMLString: true
                }
              ).then(() => {
                let params = {
                  workId: this.workId,
                  consUnitComment: this.consUnitComment,
                  reportCode: this.reportCode
                }
                setCommentWork(params).then(res=>{
                  console.log(res)
                  if(res.data.code == 200){
                    Message.success('提交成功')
                  }else if(res.data.code == 500){
                    // Message.error('作业已验收，施工方意见不能修改')
                  }
                })
                let params1 = {
                  workId: this.workId,
                  supervisorComment: this.supervisorComment,
                  passFlag: this.passFlag
                }
                setSupervisorWork(params1).then(res=>{
                  console.log(res)
                  if(res.data.code == 200){
                    Message.success('提交成功')
                  }
                })
              });
            }else{
              let params = {
                workId: this.workId,
                consUnitComment: this.consUnitComment,
                reportCode: this.reportCode
              }
              setCommentWork(params).then(res=>{
                console.log(res)
                if(res.data.code == 200){
                  Message.success('提交成功')
                }else if(res.data.code == 500){
                  // Message.error('作业已验收，施工方意见不能修改')
                }
              })
              let params1 = {
                workId: this.workId,
                supervisorComment: this.supervisorComment,
                passFlag: this.passFlag
              }
              setSupervisorWork(params1).then(res=>{
                console.log(res)
                if(res.data.code == 200){
                  Message.success('提交成功')
                }
              })
            }
        }
        else{
          Message.error('您没有验收权限，可联系管理员添加权限！')
        }
      },
      changeConsFun(e){
        console.log(e)
        this.consUnitComment = e
      },
      changeSupersFun(e){
        console.log(e)
        this.supervisorComment = e
      },
      changeRadioFun(e){
        console.log(e)
        this.passFlag = e*1
      },
      async download(){
        let userRoleList = localStorage.getItem("userRoleList")
        if(userRoleList.indexOf("menu-1eb5389fa0be4e2a8b0c7bd978aab346") < 0){
          Message.error('您没有权限，可联系管理员添加权限！')
          return
        }
        this.downloadExcelShow = false
        this.loadingInstance = Loading.service({text:'下载中...'});
        let rn=this.$store.state.rn_view[0].content;
        let icv=this.$store.state.icv_view[0].content;
        let tp=this.$store.state.tp_view[0].content;
        // let icv_l= new Image();
        // icv_l.src= this.icv_legend;
        // let rn_l= new Image();
        // rn_l.src= this.rn_legend;
        let fileArr=[];
        // let icv_legend = await getBase64Image(icv_l);
        // let rn_legend = await getBase64Image(rn_l);
        // console.log(icv_legend.src,rn_legend.src,"rn_legend")
        fileArr.push(dataURLtoFile(this.icv_legend,`w_${this.workId}_icv_legend`));
        fileArr.push(dataURLtoFile(this.rn_legend,`w_${this.workId}_rn_legend`));
        fileArr.push(dataURLtoFile(rn.src,`w_${this.workId}_rn_view`));
        fileArr.push(dataURLtoFile(icv.src,`w_${this.workId}_icv_view`));
        if(this.detail.workType==3||this.detail.workType==4){
          fileArr.push(dataURLtoFile(tp.src,`w_${this.workId}_tp_view`));
        }
        const data=new FormData();
        fileArr.map((item)=>{
          data.append('files',item,item.name)
        })
        let config={
          headers:{'Content-Type':'multipart/form-data',token:Cookies.get('token'),Authorization:Cookies.get('token')},
          responseType: 'blob',
        }
        const InstructionManualvv = await axios.post(this.$store.state.baseUrl+'/construction/exportPdf/quantity/workAccept?workId='+this.workId,data,config)
        if(InstructionManualvv.data.size < 80){
          this.$message({
              message: '下载失败',
              type: 'warning'
          });
          this.downloadExcelShow = true
          this.loadingInstance.close();
          return
        }
        if(InstructionManualvv.data.code){
          this.$message({
              message: InstructionManualvv.data.message,
              type: 'warning'
          });
          this.loadingInstance.close();
          return
        }else{
          this.$message({
              message: '下载成功',
              type: 'success'
          });
          this.downloadExcelShow = true
          this.loadingInstance.close();
        }
        let blob = new Blob([InstructionManualvv.data], {type: 'application/pdf;charset=UTF-8'});
        let fileName = this.projectDayName+getDateSeconds()+'.pdf';
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName)
        } else {
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href) //释放内存
        }
      },
      goBack: function(){
          this.$router.go(-1);
      },
    },
    components:{
    //   reportWork,
      interventionEquip,
      compaction,
      opinion
    }
  }
</script>
<style lang="scss">
.commitCon{
    .el-input{
        width: 180px !important;
        height: 36px !important;
        margin-left: 23px;
        margin-right: 23px;
        font-size: 14px !important;
        .el-input__inner{
            width: 180px !important;
            height: 36px !important;
            border-radius: 1px !important;
        }
    }
}

</style>
<style lang="scss" scoped="">
.projectInfo{
    width: 98.5%;
    height: auto;
    padding-bottom: 21px;
    margin: 0 auto;
    background-color: #ffffff;
    margin-bottom: 12px;
    .blockHeader{
      width: 100%;
      height: 58px;
      position: relative;
        .workListTable{
          width: 1200px;
          height: 38px;
          position: absolute;
          top: 15px;
          left: 130px;
          // background-color: aquamarine;
          overflow-x: auto;
          overflow-y: hidden;
          white-space: nowrap;
          
          .workItem {
            &.activeWorkItem {
              background-color: #e96b5a;
              .workItemText {
                color: #ffffff;
              }
            }
            color: #e96b5a;
            background: #fdf0ef;
            border-color: #f6c4bd;
            height: 32px;
            width: auto;
            display: inline-block;
            line-height: 30px;
            font-size: 14px;

            margin-right: 10px;
            margin-left: 10px;
            // padding: 0 30px;
            vertical-align: top;
            border: 1px solid #e96b5a;
            box-sizing: border-box;
            transform: skewX(-20deg);
            cursor: pointer;
            .workItemText {
              display: inline-block;
              height: 100%;
              width: 100%;
              padding: 0 30px;
              line-height: 30px;
              transform: skewX(20deg);
            }
          }
        }
        .redBlock{
          height: 18px;
          width: 4px;
          position: absolute;
          background-color: #E96B5A;
          top: 19px;
          left: 20px;
        }
        .headerText{
          height: 16px;
          line-height: 16px;
          color: #222222;
          display: inline-block;
          position: absolute;
          top: 21px;
          left: 34px;
          font-weight: 600;
        }

      .addBtn{
        position: absolute;
        top: 15px;
        right: 191px;
        border-radius:2px;
      }
      .deleteBtn{
        position: absolute;
        top: 15px;
        right: 15px;
        border-radius:2px;
      }
      .copyBtn{
        position: absolute;
        top: 15px;
        right: 133px;
        border-radius:2px;
      }
      .editBtn{
        position: absolute;
        top: 15px;
        right: 75px;
        border-radius:2px;
      }
    }
    .parameterContent{
        width: 97.7%;
        height: auto;
        margin: 0 auto;
    }
    .blockContent{
      width: 97.7%;
      margin: 0 auto;
      border-top:1px solid rgba(225, 225, 225, 1);
      border-left:1px solid rgba(225, 225, 225, 1);
      
      .blockItem{
        display: flex;
        height: 45px;
        .item_type1{
          flex: 1;
        }
        .item_type2{
          flex: 2;
        }
        .itemLeft{
          width: 140px;
          height: 44px;
          float: left;
          background:rgba(242,242,245,1);
          border-bottom:1px solid rgba(225, 225, 225, 1);
          border-right:1px solid rgba(225, 225, 225, 1);
          line-height: 44px;
          padding-left: 15px;
          color: #555555;
          font-size: 14px;
        }
        .itemRight{
          // width: 100%;
          height: 44px;
          line-height: 44px;
          padding-left: 18px;
          color: #555555;
          font-size: 14px;

          overflow: hidden;
          border-bottom:1px solid rgba(225, 225, 225, 1);
          border-right:1px solid rgba(225, 225, 225, 1);
          .infoShow{
            width: 100%;
            height: 100%;
            border: 0;
            color: #555555;
            font-size: 14px;
          }
        }
      }
    }
  }
.routerChange{
    width: 100%;
    margin-top: -57px;
    padding-top: 57px;
    position: relative;
    padding-bottom: 67px;
    // margin-top: 57px;
    // min-height: 968px;
}
.lookUp{
    position: fixed;
    right: 75px;
    top: 65px;
    z-index: 1000;
  }
  .goBack{
    position: fixed;
    right: 16px;
    top: 65px;
    z-index: 1000;
  }
  .commitCon{
      height: 67px;
      width: 100%;
      position: fixed;
      left: 0;
      bottom: -6px;
      background-color: #ffffff;
      padding-top: 15px;
      z-index: 100;
      .resetBtn{
          display: inline-block;
          height: 40px;
          width: 120px;
          text-align: center;
          line-height: 40px;
          background: #F1F1F5;
          border: 1px solid #E1E1E1;
          border-radius: 20px;
          font-size: 14px;
          color: #212121;
          font-weight: 400;
          margin-left: 17px;
          cursor: pointer;
      }
      .commitBtn{
          display: inline-block;
          height: 40px;
          width: 120px;
          text-align: center;
          line-height: 40px;
          background: #E96B5A;
          border-radius: 20px;
          font-size: 14px;
          color: #ffffff;
          font-weight: 400;
          margin-left: 17px;
          cursor: pointer;
      }
  }
</style>